<ion-card class="main-card">
  <ion-card [animated]="true" class="img-card1">
   
    <ion-row class="ion-no-padding">
      <ion-col class="ion-no-padding" style="padding: 8px ;">
        <ion-skeleton-text [animated]="true" style="height: 190px;">
          <swiper-slide>
            <ion-skeleton-text [animated]="true" alt="..."></ion-skeleton-text>
          </swiper-slide>
        </ion-skeleton-text>
        <ion-row>
          <ion-skeleton-text [animated]="true" style="height: 60px;width: 60px;"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="height: 60px;width: 60px; margin-left: 10px;"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="height: 60px;width: 60px;margin-left: 10px;"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="height: 60px;width: 60px;margin-left: 10px;"></ion-skeleton-text>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-card>

  <ion-card class="img-card">
    <ion-card-header class="card-header-title">
      <ion-skeleton-text class="skeleton-text" [animated]="true"></ion-skeleton-text>
    </ion-card-header>
    <ion-card-content>
      <ion-row class="ion-no-padding" style="margin-left: 10px;">
        <ion-col size="6" class="ion-no-padding col-line-height" style="padding-right: 5px;">
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true"
            class="details-title skeleton-text">
          </ion-skeleton-text><ion-skeleton-text [animated]="true"
            class="details-title skeleton-text">
          </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text>
        </ion-col>

        <ion-col size="6" class="ion-no-padding col-line-height" style="padding-left: 5px;">
          <ion-skeleton-text [animated]="true" class="details-title skeleton-text"> </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text>
       
          <ion-skeleton-text [animated]="true" class="details-title skeleton-text"> </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text>
        
          <ion-skeleton-text [animated]="true" class="details-title skeleton-text"></ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
  <ion-card class="img-card">
    <ion-card-header class="card-header-title">
      <ion-skeleton-text class="skeleton-text" [animated]="true"></ion-skeleton-text>
    </ion-card-header>
    <ion-card-content>
      <ion-row class="ion-no-padding" style="margin-left: 10px;">
        <ion-col size="6" class="ion-no-padding col-line-height" style="padding-right: 5px;">
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true"
            class="details-title skeleton-text">
          </ion-skeleton-text><ion-skeleton-text [animated]="true"
            class="details-title skeleton-text">
          </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-title skeleton-text"> </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text>
        </ion-col>

        <ion-col size="6" class="ion-no-padding col-line-height" style="padding-left: 5px;">
          <ion-skeleton-text [animated]="true" class="details-title skeleton-text"> </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text>
       
          <ion-skeleton-text [animated]="true" class="details-title skeleton-text"> </ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text>
        
          <ion-skeleton-text [animated]="true" class="details-title skeleton-text"></ion-skeleton-text><br>
          <ion-skeleton-text [animated]="true" class="details-text skeleton-text">
          </ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</ion-card>